import { ibeAuthenticatedFetch } from '../../ibeAuth';
import { INationality } from './NationalityDropdown';

interface INationalityKeyValue {
  code: string;
  value: string;
}

/**
 * Builds the nationality dropdown options from the getNationalityList API
 * response (code -> display name). The booking URL / currency are joined in
 * from the brandInfo nationality list by matching nationalityId with code.
 * Falls back to the brandInfo list if the master list is unavailable.
 */

export const resolveNationalityOptions = async (
  apiUrl: string,
  nationalities: INationality[],
  brandId?: string,
  chainId?: string
): Promise<INationality[]> => {
  try {
    const response =
      brandId && chainId
        ? await ibeAuthenticatedFetch(brandId, chainId, `${apiUrl}/Search/getNationalityList`)
        : await fetch(`${apiUrl}/Search/getNationalityList`);
    const data = await response.json();
    //console.log("resolveNationalityOptions data:", data)
    const list: INationalityKeyValue[] = Array.isArray(data?.body) ? data?.body : [];
    if (list.length === 0) return nationalities;

    const bookingByCode = new Map<string, INationality>(
      nationalities.map((item) => [item?.nationalityId, item])
    );

    return list.map((item) => {
      const match = bookingByCode.get(item?.code);
      return {
        ...(match || {}),
        nationalityId: item?.code,
        nationalityName: item?.value,
        natitonalityBookingUrl: match?.natitonalityBookingUrl ?? '',
        currency: match?.currency ?? '',
      } as INationality;
    });
  } catch {
    return nationalities;
  }
};
